var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep5({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 107,
    viewBox: "0 0 117 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 117,
    height: 107,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 11.4476C26 9.5436 27.5436 8 29.4477 8H87.6758C89.5799 8 91.1235 9.5435 91.1235 11.4476V98.7832H26V11.4476Z",
    fill: "white",
    stroke: "#05054B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7734 33.8047V43.6529V45.0598L90.9895 78.9467L90.3537 66.8665L26.7734 33.8047Z",
    fill: "#05054B",
    strokeWidth: 1.2716,
    stroke: "#05054B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7734 57.9648V67.813V69.2199L81.4524 98.0207H90.9895V91.6623L26.7734 57.9648Z",
    fill: "#05054B",
    strokeWidth: 1.2716,
    stroke: "#05054B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4758 9.47461L26.5312 19.36V20.7722L90.99 54.7872L90.3518 42.6613L27.4758 9.47461Z",
    fill: "#05054B",
    strokeWidth: 1.27641,
    stroke: "#05054B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5675 9.64551H67.0552L90.7156 20.2304V30.8497L50.0742 9.64551H52.5675Z",
    fill: "#05054B",
    strokeWidth: 1.2716,
    stroke: "#05054B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1367 90.6575V81.7285L57.0075 98.0215H39.3359L27.1367 92.2548V90.6575Z",
    fill: "#05054B",
    strokeWidth: 1.2716,
    stroke: "#05054B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4883 11.448C26.4883 9.8129 27.8139 8.4873 29.449 8.4873H87.6772C89.3123 8.4873 90.6379 9.8129 90.6379 11.448V25.2649H26.4883V11.448Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8241 39.5273H45.8488C44.7954 39.5273 43.9414 40.3813 43.9414 41.4348V79.5829C43.9414 80.6364 44.7954 81.4903 45.8488 81.4903H73.8241C74.8775 81.4903 75.7315 80.6364 75.7315 79.5829V41.4348C75.7315 40.3813 74.8775 39.5273 73.8241 39.5273Z",
    fill: "white",
    strokeWidth: 1.2716,
    strokeLinejoin: "round",
    stroke: "#05054B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1172 48.4287H71.2777",
    strokeWidth: 1.2716,
    stroke: "#DD1160"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1172 54.7861H71.2777",
    strokeWidth: 1.2716,
    stroke: "#DD1160"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1172 61.1445H71.2777",
    strokeWidth: 1.2716,
    stroke: "#DD1160"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1172 67.5029H71.2777",
    strokeWidth: 1.2716,
    stroke: "#DD1160"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9434 70.7275H53.4727V78.2084H53.9434V70.7275Z",
    fill: "#33333F"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4697 70.7275H54.2344V78.2084H54.4697V70.7275Z",
    fill: "#33333F"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2393 70.7275H55.0039V78.2084H55.2393V70.7275Z",
    fill: "#33333F"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M56.501 70.7275H56.2656V78.2084H56.501V70.7275Z",
    fill: "#33333F"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M57.501 70.7275H57.2656V78.2084H57.501V70.7275Z",
    fill: "#33333F"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7676 70.6816H58.2969V78.1625H58.7676V70.6816Z",
    fill: "#33333F"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3252 70.7275H59.0898V78.2084H59.3252V70.7275Z",
    fill: "#33333F"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8019 70.6816H60.0664V78.1625H60.8019V70.6816Z",
    fill: "#33333F"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0947 70.7275H61.8594V78.2084H62.0947V70.7275Z",
    fill: "#33333F"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5606 70.7275H61.0898V78.2084H61.5606V70.7275Z",
    fill: "#33333F"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0949 70.7275H62.3594V78.2084H63.0949V70.7275Z",
    fill: "#33333F"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3574 70.7275H63.8867V78.2084H64.3574V70.7275Z",
    fill: "#33333F"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9189 70.7275H64.6836V78.2084H64.9189V70.7275Z",
    fill: "#33333F"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4883 25.2646H90.6379",
    strokeWidth: 1.2716,
    stroke: "#05054B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep5);
export default __webpack_public_path__ + "static/media/step_5.fcb277efed5b2a375b41b2d5883faf05.svg";
export { ForwardRef as ReactComponent };